import { Box, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { type Amount, TransactionDirection } from "Infrastructure/Api/Api";
import { formatCurrency } from "Utils/CurrencyUtils";
import { formatTransactionDateTime } from "Utils/DateUtils";
import type { ViewerTransactionDirection } from "Utils/TransactionUtils";

type Props = {
  dateCreated: string;
  amount: Amount;
  direction: ViewerTransactionDirection;
};

export const AmountWithDate = ({
  dateCreated,
  amount: { value: amount, currencyCode },
  direction,
}: Props) => (
  <Box
    component="span"
    display="flex"
    flexDirection="column"
    alignItems="flex-end"
    gap={0.5}
  >
    <Typography
      fontWeight={600}
      color={
        direction === TransactionDirection.Outgoing ? Colors.RedDark : undefined
      }
    >
      {direction === TransactionDirection.Outgoing ? "-" : ""}
      {formatCurrency({ amount, currencyCode })}
    </Typography>
    {!!dateCreated && (
      <Typography fontSize="0.75rem" color={Colors.TextLight}>
        {formatTransactionDateTime(dateCreated)}
      </Typography>
    )}
  </Box>
);
